var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1226 5.67277C18.0033 5.67366 18.8476 6.0239 19.4703 6.64661C20.093 7.26932 20.4432 8.11365 20.4441 8.99429V15.015C20.4432 15.8957 20.093 16.74 19.4703 17.3627C18.8476 17.9854 18.0033 18.3357 17.1226 18.3366H6.87778C5.99647 18.3354 5.15163 17.9846 4.52885 17.361C3.90606 16.7374 3.55625 15.8921 3.55625 15.0108V8.99006C3.55849 8.11022 3.90929 7.26711 4.53183 6.64536C5.15438 6.02361 5.99793 5.67388 6.87778 5.67277H17.1226V5.67277ZM17.1226 3.7254H6.87778C5.48111 3.7254 4.14159 4.27994 3.15361 5.26713C2.16562 6.25432 1.61001 7.5934 1.60889 8.99006V15.0108C1.60889 16.4082 2.164 17.7484 3.15211 18.7365C4.14022 19.7246 5.48038 20.2797 6.87778 20.2797H17.1226C18.52 20.2797 19.8602 19.7246 20.8483 18.7365C21.8364 17.7484 22.3915 16.4082 22.3915 15.0108V8.99006C22.3904 7.5934 21.8348 6.25432 20.8468 5.26713C19.8588 4.27994 18.5193 3.7254 17.1226 3.7254V3.7254Z",
    fill: "#D5322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65869 10.0222V13.9787C9.65869 14.9016 10.8347 15.446 11.6975 14.9219L14.9589 12.9441C15.7099 12.4885 15.7099 11.5123 14.9589 11.0568L11.6975 9.07811C10.8373 8.55147 9.65869 9.09927 9.65869 10.0222Z",
    fill: "#D5322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.42752ac59896db37b1616e3af1e85001.svg";
export { ForwardRef as ReactComponent };